export default __webpack_public_path__ + "static/media/dreamscape.317d47ef.mp4";